// extracted by mini-css-extract-plugin
export default {"container":"community-association-manager_container__sWePU"};